import React, { useEffect, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import { usePendingActivation, useEligibilityActions } from '../../../hooks/useEligibilityEngine';
import './PendingActivationBanner.css';

/**
 * Formats an ISO date string into a human-readable date and time.
 * e.g. "Apr 1, 2026 at 9:00 AM"
 */
const formatActivationDate = isoDate => {
  const d = new Date(isoDate);
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

const PendingActivationBanner = () => {
  const activationDate = usePendingActivation();
  const { clearPendingActivation } = useEligibilityActions();

  // Re-render every minute to auto-dismiss when the activation time passes.
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (!activationDate) return undefined;
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, [activationDate]);

  // Auto-clear from Redux state once the activation time has passed so the
  // banner is not shown again on the next render cycle.
  useEffect(() => {
    if (!activationDate) return;
    if (new Date(activationDate) <= now) {
      clearPendingActivation();
    }
  }, [activationDate, now, clearPendingActivation]);

  if (!activationDate || new Date(activationDate) <= now) {
    return null;
  }

  return (
    <div className='pending-activation-banner' data-testid='pending-activation-banner'>
      <Icon name='clock outline' className='pending-activation-banner__icon' />
      <span>
        Published ruleset pending activation &mdash; will go live on{' '}
        <strong data-testid='pending-activation-banner-date'>
          {formatActivationDate(activationDate)}
        </strong>
        .
      </span>
    </div>
  );
};

export default PendingActivationBanner;
